<template>
  <div v-if="isLoaded">

<!--    <transition name="fade">-->
<!--      <div class="row" v-if="moduleInfoMessage">-->
<!--        <div class="col-12">-->
<!--          <div style="-->
<!--                color: rgb(90, 90, 90);-->
<!--                font-size: 16px;-->
<!--                padding: 10px;-->
<!--                background: #F8F8F8;-->
<!--                border: 1px solid rgb(90, 90, 90);-->
<!--                margin-bottom: 20px;-->
<!--                border-radius: 3px">-->
<!--            {{ moduleInfoMessage }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->

    <transition name="fade">
      <div class="row" v-if="unitsErrorMessage || terminErrorMessage || moduleUnitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }} {{ terminErrorMessage }} {{ moduleUnitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-right">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.termin"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="startTimeKey"
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.startTime"
                  :required="true"
                  :hoursArray=hoursArrayDropdown
                  :minutesArray=minutesArrayDropdown
                  label="Startzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="endTimeKey"
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.endTime"
                  :required="true"
                  :hoursArray=hoursArrayDropdown
                  :minutesArray=minutesArrayDropdown
                  label="Endzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="presenceDropdown"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"
                     @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12" v-if="!unitsReduction">
          <BaseCheckbox
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.overwrite"
              label="Überschreiben"
              @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <SelectVue v-model="formData.coachType"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="coachTypeDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coachart"
                     placeholder="Wählen Sie Coachart"
                     :validation="v$.coachType"
                     :messages="v$.coachType.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled || isSystemAddedMeeting || isDigitalSignature"
                v-model="formData.signature"
                label="Unterschrift"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isSystemAddedMeeting"
                v-model="formData.billed"
                label="Abgerechnet"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class=" mt-4">
            <BaseCheckbox
                :disabled="isSystemAddedMeeting || isCoachBilled"
                v-model="formData.paid"
                label="Bezahlt"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                v-model="formData.homeVisit"
                label="Hausbesuch"
                :labelPosition="'right'"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-8 col-sm-12">
          <SelectVue v-model="formData.moduleId"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Modul"
                     placeholder="Modul auswählen"
                     :validation="v$.moduleId"
                     :messages="v$.moduleId.required.$message"
                     @update:modelValue="onChangeModule"/>
        </div>
        <div v-if="(currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') && protocolId"
             class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.sectionNumber"
              :validation="v$.sectionNumber"
              :messages="v$.sectionNumber?.required?.$message"
              :label="$t('general.section')"
              :disabled="!updateAsAdmin"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12"
             v-if="
                 ( currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT') && !originalIsSystemAddedMeeting">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput v-model="formData.meetingTopic"
                     label="Sitzungsthema"
                     :required="true"
                     :validation="v$.meetingTopic"
                     :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 d-flex justify-content-end">
          <BaseCheckbox
              v-model="formData.geva"
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              label="Geva-Potentialanalyse"
              :labelPosition="'right'"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage && !terminErrorMessage && !moduleUnitsErrorMessage"
           class="d-flex justify-content-center w-100 mt-3">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import { ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown, addDeletedModuleToDropdown} from '@/shared/portal/commonFunctions';
import {
  portalPrivateCoachingCheckModule,
  getAssignedCoachesForDropdown,
  getAssignedModulesForDropdown, generateHoursArray
} from '@/shared/portal/privateCoachingFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const micNewUnitsCalculationStartFrom = process.env.VUE_APP_MIC_NEW_UNITS_CALCULATION_START_FROM
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const moduleDropdown = ref([]);
const unitsErrorMessage = ref('');
const terminErrorMessage = ref('');
const moduleInfoMessage = ref('');
const moduleUnitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const isSystemAddedMeeting = ref(false);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const originalIsSystemAddedMeeting = ref(false) // Need this for update as admin logic

const emit = defineEmits(['update:modelValue', 'update:submitForm']);

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: [Number, String],
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
  unitsReduction: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  moduleId: null,
  sectionNumber: null,
  geva: false,
  meetingTopic: '',
  description: '',
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  units: requiredRule(t),
  meetingTopic: requiredRule(t),
  moduleId: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer

    if (props.protocolId) {
      if (updateAsAdmin.value === true) {
        await portalPrivateCoachingService.updateAsAdminGoWorkMobileProtocol(formData.value, +protocolId.value);
      } else {
        await portalPrivateCoachingService.updateGoWorkMobileProtocol(formData.value, +protocolId.value);
      }
    } else {
      await portalPrivateCoachingService.postGoWorkMobileProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalPrivateCoachingService.getProtocolData(protocolId.value);
    const {protocol} = data?.data;

    isBilled.value = protocol.invoiced;
    isCoachBilled.value = protocol.coachInvoiced;
    isSystemAddedMeeting.value = protocol.systemAddedMeeting;

    // Save original values for update as admin
    originalIsBilled.value = protocol.invoiced;
    originalIsCoachBilled.value = protocol.coachInvoiced;
    originalIsSystemAddedMeeting.value = protocol.systemAddedMeeting

    addDeletedCoachToDropdown(protocol.coach, coachDropdown);
    addDeletedModuleToDropdown(protocol.module, moduleDropdown);

    formData.value = {
      ...protocol,
      coachId: protocol?.coach?.id,
      moduleId: protocol?.module?.id,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
  } catch (error) {
    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    await ErrorToast(error);
  }
}


const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

    onChangeUnits(units);

    if (Number.isInteger(parseFloat(units))) { // Only if is rounded number
      let unitDuration = 45;

      // Check a presence type
      if ((formData.value.presence)) {
        if (formData.value.presence === 'anwesend') {
          units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
        } else {
          units = 1;
        }
      }

      // If presenceType is selected and overview is true, calculate units
      if (formData.value.overwrite === true) {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      }

      onChangeModule(formData.value.moduleId);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (!Number.isInteger(parsedValue)) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else if (parsedValue > 2) {
    unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten oder 90 Minuten betragen.';
  } else {
    unitsErrorMessage.value = '';
  }
}


async function onChangeModule(newValue) {
  try {
    if (newValue) {
      // const {data} = await portalPrivateCoachingService.getSumUnitsDoneForModule(
      //     +coachingId.value,
      //     +newValue,
      //     protocolId.value,
      // );
      // const [errorMessage, infoMessage] = portalPrivateCoachingCheckModule(data, formData, updateAsAdmin.value);
      //
      // moduleInfoMessage.value = infoMessage;
      // moduleUnitsErrorMessage.value = errorMessage;

    } else {
      moduleInfoMessage.value = '';
      moduleUnitsErrorMessage.value = '';
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

//watch(
//    () => [
//      formData.value.startTime,
//      formData.value.endTime,
//      formData.value.presence,
//      formData.value.overwrite,
//    ],
//    calculateTimeDifference,
//);

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  coachTypeDropdown.value = getEnums?.value?.portalCoachTypes || [];
}

const hoursArrayDropdown = computed(() => {
  return originalIsSystemAddedMeeting.value
      ? generateHoursArray(20, 20)
      : generateHoursArray(0, 23);
});


const minutesArrayDropdown = computed(() => {
  return originalIsSystemAddedMeeting.value
      ? ["00", "45"]
      : ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]
})

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
    isSystemAddedMeeting.value = false;

    formRules.value = {
      ...formRules.value,
      sectionNumber: requiredRule(t),
    }

  } else {

    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
    isSystemAddedMeeting.value = originalIsSystemAddedMeeting.value

    unitsErrorMessage.value = ''
    terminErrorMessage.value = ''
    moduleInfoMessage.value = ''
    moduleUnitsErrorMessage.value = ''

    formRules.value = {
      ...formRules.value,
      sectionNumber: '',
    }
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    protocolId.value != null && protocolId.value !== ''
);


onMounted(async () => {
  await Promise.all([
    getAssignedCoachesForDropdown(+coachingId.value, coachDropdown),
    getAssignedModulesForDropdown(+coachingId.value, moduleDropdown),
    getEnumsDropdown(),
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>